module.exports = VueClipboard;